/* eslint-disable no-useless-assignment */
// @ts-nocheck
import { merge } from '../../helper';

import * as exModal from '../../components/modal';
import * as exInput from '../../forms/input';
import * as exElement from '../element';

// ----------------------------------------------------------------------------

function create(config = {}): any {
    // Default Config
    const defConfig = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements = {};

    // Create element (form color)
    const elFormColor = exElement.create({
        merge: defConfig,
        class: {
            new: 'form-color',
        },
    });
    elements.element = elFormColor;

    // ------------------------------------------------------------------------

    // Create element (color picker)
    const elColorPicker = exElement.create({
        merge: defConfig.picker,
        class: {
            new: 'color-picker',
        },
    });
    elFormColor.appendChild(elColorPicker);
    elements.colorPicker = elColorPicker;

    // ------------------------------------------------------------------------

    // Create element (input color)
    const elInputColor = exElement.create({
        merge: defConfig.inputColor,
        class: {
            new: 'input-color form-control',
        },
    });
    elFormColor.appendChild(elInputColor);
    elements.inputColor = elInputColor;

    // ------------------------------------------------------------------------

    // Create element (color palette)
    const elColorPalette = exElement.create({
        merge: defConfig.colorBlock,
        class: {
            new: 'color-palette',
        },
    });
    elColorPicker.appendChild(elColorPalette);
    elements.colorBlock = elColorPalette;

    // Create element (canvas palette)
    const elCanvasPalette = exElement.create({
        merge: defConfig.canvasPalette,
        tag: 'canvas',
        class: {
            new: 'canvas-palette',
        },
        style: {
            height: '150px',
            width: '150px',
        },
    });
    elColorPalette.appendChild(elCanvasPalette);
    elements.canvasPalette = elCanvasPalette;

    // Create element (color indicator palette)
    const elColorIndicatorPalette = exElement.create({
        merge: defConfig.colorIndicatorPalette,
        tag: 'span',
        class: {
            new: 'color-indicator-palette',
        },
        style: {
            left: '65px',
            top: '65px',
        },
    });
    elColorPalette.appendChild(elColorIndicatorPalette);
    elements.colorIndicatorPalette = elColorIndicatorPalette;

    // Create element (indicator palette)
    const elIndicatorPalette = exElement.create({
        merge: defConfig.indicatorPalette,
        class: {
            new: 'indicator',
        },
    });
    elColorIndicatorPalette.appendChild(elIndicatorPalette);
    elements.indicatorPalette = elIndicatorPalette;

    // ------------------------------------------------------------------------

    // Create element (color slider)
    const elColorSlider = exElement.create({
        merge: defConfig.colorSlider,
        class: {
            new: 'color-slider',
        },
    });
    elColorPicker.appendChild(elColorSlider);
    elements.colorSlider = elColorSlider;

    // Create element (canvas slider)
    const elCanvasSlider = exElement.create({
        merge: defConfig.canvasSlider,
        tag: 'canvas',
        class: {
            new: 'canvas-slider',
        },
        style: {
            height: '150px',
            width: '16px',
        },
    });
    elColorSlider.appendChild(elCanvasSlider);
    elements.canvasSlider = elCanvasSlider;

    // Create element (color indicator slider)
    const elColorIndicatorSlider = exElement.create({
        merge: defConfig.colorIndicatorSlider,
        tag: 'span',
        class: {
            new: 'color-indicator-slider',
        },
        style: {
            left: '8px',
            top: '-3px',
        },
    });
    elColorSlider.appendChild(elColorIndicatorSlider);
    elements.colorIndicatorSlider = elColorIndicatorSlider;

    // Create element (indicator slider)
    const elIndicatorSlider = exElement.create({
        merge: defConfig.indicatorSliderM,
        class: {
            new: 'indicator',
        },
    });
    elColorIndicatorSlider.appendChild(elIndicatorSlider);
    elements.indicatorSlider = elIndicatorSlider;

    // ------------------------------------------------------------------------

    // Create element (color values)
    const elColorValues = exElement.create({
        merge: defConfig.colorValues,
        class: {
            new: 'color-values',
        },
    });
    elColorPicker.appendChild(elColorValues);
    elements.colorValues = elColorValues;

    // Create element (input values)
    const inputValues = exInput.create({
        merge: defConfig.inputValues,
        type: 'text',
        class: {
            add: 'input-values',
        },
    });
    elColorValues.appendChild(inputValues.element);
    elements.inputValues = inputValues.element;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // Return
    return elements;
}

function settings(elements, config = {}): any {
    // Source
    const src = {
        palette: {
            x: 482,
            y: 0,
            d: false,
        },
        slider: {
            x: 0,
            y: 0,
            d: false,
        },
        rgbaColor: 'rgba(255,0,0,1)',
    };

    //
    const ctx1 = elements.canvasPalette.getContext('2d');
    const width1 = elements.canvasPalette.width;
    const height1 = elements.canvasPalette.height;

    //
    const ctx2 = elements.canvasSlider.getContext('2d');
    const width2 = elements.canvasSlider.width;
    const height2 = elements.canvasSlider.height;

    // ------------------------------------------------------------------------

    ctx1.rect(0, 0, width1, height1);
    createColorPalette();

    function createColorPalette(): any {
        //
        ctx1.clearRect(0, 0, width1, height1);

        //
        ctx1.fillStyle = src.rgbaColor;
        ctx1.fillRect(1, 0, width1, height1 - 1);

        // Create linear gradient (white)
        const whiteGradient = ctx2.createLinearGradient(0, 0, width1, 0);
        whiteGradient.addColorStop(0, '#fff');
        whiteGradient.addColorStop(1, 'transparent');
        ctx1.fillStyle = whiteGradient;
        ctx1.fillRect(0, 0, width1, height1);

        // Create linear gradient (black)
        const blackGradient = ctx2.createLinearGradient(0, 0, 0, height1);
        blackGradient.addColorStop(0, 'transparent');
        blackGradient.addColorStop(1, '#000');
        ctx1.fillStyle = blackGradient;
        ctx1.fillRect(0, 1, width1, height1);
    }

    ctx2.rect(0, 0, width2, height2);
    createColorSlider();

    function createColorSlider(): any {
        // Create linear gradient (hue)
        const hueGradient = ctx2.createLinearGradient(0, 0, 0, height1);
        hueGradient.addColorStop(0.0, '#ff0000');
        hueGradient.addColorStop(0.17, '#ff00ff');
        hueGradient.addColorStop(0.33, '#0000ff');
        hueGradient.addColorStop(0.5, '#00ffff');
        hueGradient.addColorStop(0.67, '#00ff00');
        hueGradient.addColorStop(0.83, '#ffff00');
        hueGradient.addColorStop(1.0, '#ff0000');
        ctx2.fillStyle = hueGradient;
        ctx2.fillRect(0, 0, width2, height2);
    }

    // ------------------------------------------------------------------------

    function mouseCoords(evt): any {
        // Get bounding client rect
        const canvasOffset = evt.target.getBoundingClientRect();

        //
        let x = evt.pageX - canvasOffset.left;
        let y = evt.pageY - canvasOffset.top;

        if (x < 0) {
            x = 0;
        }
        if (x >= evt.target.width) {
            x = evt.target.width - 1;
        }
        if (y < 0) {
            y = 0;
        }
        if (y >= evt.target.height) {
            y = evt.target.height - 1;
        }

        //
        if (evt.target === elements.canvasPalette) {
            src.palette.x = x;
            src.palette.y = y;
        }
        if (evt.target === elements.canvasSlider) {
            src.slider.x = x;
            src.slider.y = y;
        }
    }

    function updateColorPalette(evt): any {
        mouseCoords(evt);

        // Get image data
        const imgData = ctx1.getImageData(src.palette.x, src.palette.y, 1, 1).data;

        if (config.alpha === true) {
            src.rgbaColor = 'rgba(' + imgData[0] + ',' + imgData[1] + ',' + imgData[2] + ',1)';
        } else {
            src.rgbaColor = 'rgb(' + imgData[0] + ',' + imgData[1] + ',' + imgData[2] + ')';
        }

        //
        updateColorIndicatorPalette();

        //
        elements.indicatorPalette.style.backgroundColor = src.rgbaColor;
        //
        elements.inputValues.value = src.rgbaColor;
        //
        elements.inputColor.style.backgroundColor = src.rgbaColor;

        // If using function change
        if (typeof config.fnChange === 'function') {
            config.fnChange(src.rgbaColor);
        }
    }

    function updateColorIndicatorPalette(): any {
        //
        elements.colorIndicatorPalette.style.top = src.palette.y + 'px';
        elements.colorIndicatorPalette.style.left = src.palette.x + 'px';
    }

    function updateColorSlider(evt): any {
        mouseCoords(evt);

        // Get image data
        const imgData = ctx2.getImageData(0, src.slider.y, 1, 1).data;

        if (config.alpha === true) {
            src.rgbaColor = 'rgba(' + imgData[0] + ',' + imgData[1] + ',' + imgData[2] + ',1)';
        } else {
            src.rgbaColor = 'rgb(' + imgData[0] + ',' + imgData[1] + ',' + imgData[2] + ')';
        }

        //
        updateColorIndicatorSlider();

        //
        createColorPalette();

        //
        updateColorPalette(evt);
    }

    function updateColorIndicatorSlider(): any {
        //
        elements.colorIndicatorSlider.style.top = src.slider.y - 2 + 'px';
        elements.colorIndicatorSlider.style.left = '8px';
    }

    // ------------------------------------------------------------------------

    // Create event (input color)
    elements.inputColor.addEventListener('click', function (): any {
        if (!elements.colorPicker.hasClass('show')) {
            elements.colorPicker.addClass('show');
        } else {
            elements.colorPicker.removeClass('show');
        }
    });

    // Create event (canvas palette)
    elements.canvasPalette.addEventListener('mousedown', function (evt): any {
        src.palette.d = true;
        updateColorPalette(evt);
    });
    elements.canvasPalette.addEventListener('mouseup', function (): any {
        src.palette.d = false;
    });
    elements.canvasPalette.addEventListener('mousemove', function (evt): any {
        if (src.palette.d) {
            updateColorPalette(evt);
        }
    });
    elements.canvasPalette.addEventListener('mouseleave', function (): any {
        src.palette.d = false;
    });

    // Create event (canvas slider)
    elements.canvasSlider.addEventListener('mousedown', function (evt): any {
        src.slider.d = true;
        updateColorSlider(evt);
    });
    elements.canvasSlider.addEventListener('mouseup', function (): any {
        src.slider.d = false;
    });
    elements.canvasSlider.addEventListener('mousemove', function (evt): any {
        if (src.slider.d) {
            updateColorSlider(evt);
        }
    });
    elements.canvasSlider.addEventListener('mouseleave', function (): any {
        src.slider.d = false;
    });

    // Create event (input values)
    elements.inputValues.addEventListener('input', function (): any {
        //
    });
}

// ----------------------------------------------------------------------------

function modal(config = {}): any {
    // Create color
    const color = create({
        merge: config,
    });

    // Create modal
    const modal = exModal.create({
        merge: config.modal,
        backdrop: 'static',
        destroy: true,
    });

    //
    modal.child(color.element).showModal();
}

// ----------------------------------------------------------------------------

function type(type, config = {}): any {
    // Default Config
    const defConfig = {
        first: '',
        last: '',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Init
    let color = '';

    // Switch Type
    switch (type) {
        case 'primary':
            color = defConfig.first + 'primary' + defConfig.last;
            break;
        case 'secondary':
            color = defConfig.first + 'secondary' + defConfig.last;
            break;
        case 'success':
            color = defConfig.first + 'success' + defConfig.last;
            break;
        case 'danger':
            color = defConfig.first + 'danger' + defConfig.last;
            break;
        case 'warning':
            color = defConfig.first + 'warning' + defConfig.last;
            break;
        case 'info':
            color = defConfig.first + 'info' + defConfig.last;
            break;
        case 'light':
            color = defConfig.first + 'light' + defConfig.last;
            break;
        case 'dark':
            color = defConfig.first + 'dark' + defConfig.last;
            break;
        // No default
    }

    // ------------------------------------------------------------------------

    // Return
    return color;
}

// ----------------------------------------------------------------------------

const convert = (function (): any {
    function rgbToHex(rgb): any {
        const sep = rgb.indexOf(',') > -1 ? ',' : ' ';
        rgb = rgb.substr(4).split(')')[0].split(sep);

        let r = Number(rgb[0]).toString(16);
        let g = Number(rgb[1]).toString(16);
        let b = Number(rgb[2]).toString(16);

        if (r.length == 1) {
            r = '0' + r;
        }
        if (g.length == 1) {
            g = '0' + g;
        }
        if (b.length == 1) {
            b = '0' + b;
        }

        return '#' + r + g + b;
    }

    function rgbAToHexA(rgba): any {
        const sep = rgba.indexOf(',') > -1 ? ',' : ' ';
        rgba = rgba.substr(5).split(')')[0].split(sep);

        if (rgba.indexOf('/') > -1) {
            rgba.splice(3, 1);
        }

        for (const R in rgba) {
            const r = rgba[R];

            if (r.indexOf('%') > -1) {
                const p = r.substr(0, r.length - 1) / 100;

                if (R < 3) {
                    rgba[R] = Math.round(p * 255);
                } else {
                    rgba[R] = p;
                }
            }
        }

        let r = Number(rgba[0]).toString(16);
        let g = Number(rgba[1]).toString(16);
        let b = Number(rgba[2]).toString(16);
        let a = Math.round(Number(rgba[3]) * 255).toString(16);

        if (r.length == 1) {
            r = '0' + r;
        }
        if (g.length == 1) {
            g = '0' + g;
        }
        if (b.length == 1) {
            b = '0' + b;
        }
        if (a.length == 1) {
            a = '0' + a;
        }

        return '#' + r + g + b + a;
    }

    function rgbToHsl(rgb): any {
        const sep = rgb.indexOf(',') > -1 ? ',' : ' ';
        rgb = rgb.substr(4).split(')')[0].split(sep);

        for (const R in rgb) {
            const r = rgb[R];

            if (r.indexOf('%') > -1) {
                rgb[R] = Math.round((r.substr(0, r.length - 1) / 100) * 255);
            }
        }

        // Make r, g, and b fractions of 1
        const r = rgb[0] / 255;
        const g = rgb[1] / 255;
        const b = rgb[2] / 255;

        // find greatest and smallest channel values
        const cmin = Math.min(r, g, b);
        const cmax = Math.max(r, g, b);
        const delta = cmax - cmin;
        let h = 0;
        let s = 0;
        let l = 0;

        /*
         * calculate hue
         * no difference
         */
        if (delta == 0) {
            h = 0;
        }
        // red is max
        else if (cmax == r) {
            h = ((g - b) / delta) % 6;
        }
        // green is max
        else if (cmax == g) {
            h = (b - r) / delta + 2;
        }
        // blue is max
        else {
            h = (r - g) / delta + 4;
        }

        h = Math.round(h * 60);

        // make negative hues positive behind 360°
        if (h < 0) {
            h += 360;
        }

        // calculate lightness
        l = (cmax + cmin) / 2;

        // calculate saturation
        s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

        // multiply l and s by 100
        s = Number((s * 100).toFixed(1));
        l = Number((l * 100).toFixed(1));

        return 'hsl(' + h + ',' + s + '%,' + l + '%)';
    }

    function rgbAToHslA(rgba): any {
        const sep = rgba.indexOf(',') > -1 ? ',' : ' ';
        rgba = rgba.substr(5).split(')')[0].split(sep);

        // slider the slash if using space-separated syntax
        if (rgba.indexOf('/') > -1) {
            rgba.splice(3, 1);
        }

        for (const R in rgba) {
            const r = rgba[R];

            if (r.indexOf('%') > -1) {
                const p = r.substr(0, r.length - 1) / 100;

                if (R < 3) {
                    rgba[R] = Math.round(p * 255);
                }
            }
        }

        // make r, g, and b fractions of 1
        const r = rgba[0] / 255;
        const g = rgba[1] / 255;
        const b = rgba[2] / 255;
        const a = rgba[3];

        // find greatest and smallest channel values
        const cmin = Math.min(r, g, b);
        const cmax = Math.max(r, g, b);
        const delta = cmax - cmin;
        let h = 0;
        let s = 0;
        let l = 0;

        /*
         * calculate hue
         * no difference
         */
        if (delta == 0) {
            h = 0;
        }
        // red is max
        else if (cmax == r) {
            h = ((g - b) / delta) % 6;
        }
        // green is max
        else if (cmax == g) {
            h = (b - r) / delta + 2;
        }
        // blue is max
        else {
            h = (r - g) / delta + 4;
        }

        h = Math.round(h * 60);

        // make negative hues positive behind 360°
        if (h < 0) {
            h += 360;
        }

        // calculate lightness
        l = (cmax + cmin) / 2;

        // calculate saturation
        s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));

        // multiply l and s by 100
        s = Number((s * 100).toFixed(1));
        l = Number((l * 100).toFixed(1));

        return 'hsla(' + h + ',' + s + '%,' + l + '%,' + a + ')';
    }

    function hexToRgb(hex): any {
        let r = 0;
        let g = 0;
        let b = 0;

        // 3 digits
        if (hex.length == 4) {
            r = '0x' + hex[1] + hex[1];
            g = '0x' + hex[2] + hex[2];
            b = '0x' + hex[3] + hex[3];
        }
        // 6 digits
        else if (hex.length == 7) {
            r = '0x' + hex[1] + hex[2];
            g = '0x' + hex[3] + hex[4];
            b = '0x' + hex[5] + hex[6];
        }

        return 'rgb(' + Number(r) + ',' + Number(g) + ',' + Number(b) + ')';
    }

    function hexAToRgbA(hex): any {
        let r = 0;
        let g = 0;
        let b = 0;
        let a = 1;

        if (hex.length == 5) {
            r = '0x' + hex[1] + hex[1];
            g = '0x' + hex[2] + hex[2];
            b = '0x' + hex[3] + hex[3];
            a = '0x' + hex[4] + hex[4];
        } else if (hex.length == 9) {
            r = '0x' + hex[1] + hex[2];
            g = '0x' + hex[3] + hex[4];
            b = '0x' + hex[5] + hex[6];
            a = '0x' + hex[7] + hex[8];
        }

        a = Number((a / 255).toFixed(3));

        return 'rgba(' + Number(r) + ',' + Number(g) + ',' + Number(b) + ',' + a + ')';
    }

    function hexToHsl(hex): any {
        // convert hex to RGB first
        let r = 0;
        let g = 0;
        let b = 0;

        if (hex.length == 4) {
            r = '0x' + hex[1] + hex[1];
            g = '0x' + hex[2] + hex[2];
            b = '0x' + hex[3] + hex[3];
        } else if (hex.length == 7) {
            r = '0x' + hex[1] + hex[2];
            g = '0x' + hex[3] + hex[4];
            b = '0x' + hex[5] + hex[6];
        }

        // then to HSL
        r /= 255;
        g /= 255;
        b /= 255;

        const cmin = Math.min(r, g, b);
        const cmax = Math.max(r, g, b);
        const delta = cmax - cmin;
        let h = 0;
        let s = 0;
        let l = 0;

        if (delta == 0) {
            h = 0;
        } else if (cmax == r) {
            h = ((g - b) / delta) % 6;
        } else if (cmax == g) {
            h = (b - r) / delta + 2;
        } else {
            h = (r - g) / delta + 4;
        }

        h = Math.round(h * 60);

        if (h < 0) {
            h += 360;
        }

        l = (cmax + cmin) / 2;
        s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
        s = Number((s * 100).toFixed(1));
        l = Number((l * 100).toFixed(1));

        return 'hsl(' + h + ',' + s + '%,' + l + '%)';
    }

    function hexAToHslA(hex): any {
        let r = 0;
        let g = 0;
        let b = 0;
        let a = 1;

        // 4 digits
        if (hex.length == 5) {
            r = '0x' + hex[1] + hex[1];
            g = '0x' + hex[2] + hex[2];
            b = '0x' + hex[3] + hex[3];
            a = '0x' + hex[4] + hex[4];
        }
        // 8 digits
        else if (hex.length == 9) {
            r = '0x' + hex[1] + hex[2];
            g = '0x' + hex[3] + hex[4];
            b = '0x' + hex[5] + hex[6];
            a = '0x' + hex[7] + hex[8];
        }

        // normal conversion to HSLA
        r /= 255;
        g /= 255;
        b /= 255;

        const cmin = Math.min(r, g, b);
        const cmax = Math.max(r, g, b);
        const delta = cmax - cmin;
        let h = 0;
        let s = 0;
        let l = 0;

        if (delta == 0) {
            h = 0;
        } else if (cmax == r) {
            h = ((g - b) / delta) % 6;
        } else if (cmax == g) {
            h = (b - r) / delta + 2;
        } else {
            h = (r - g) / delta + 4;
        }

        h = Math.round(h * 60);

        if (h < 0) {
            h += 360;
        }

        l = (cmax + cmin) / 2;
        s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
        s = Number((s * 100).toFixed(1));
        l = Number((l * 100).toFixed(1));

        a = (a / 255).toFixed(3);

        return 'hsla(' + h + ',' + s + '%,' + l + '%,' + a + ')';
    }

    function hslToRgb(hsl, isPct): any {
        const sep = hsl.indexOf(',') > -1 ? ',' : ' ';
        hsl = hsl.substr(4).split(')')[0].split(sep);
        isPct = isPct === true;

        let h = hsl[0];
        const s = hsl[1].substr(0, hsl[1].length - 1) / 100;
        const l = hsl[2].substr(0, hsl[2].length - 1) / 100;

        // slider label and convert to degrees (if necessary)
        if (h.indexOf('deg') > -1) {
            h = h.substr(0, h.length - 3);
        } else if (h.indexOf('rad') > -1) {
            h = Math.round((h.substr(0, h.length - 3) / (2 * Math.PI)) * 360);
        } else if (h.indexOf('turn') > -1) {
            h = Math.round(h.substr(0, h.length - 4) * 360);
        }
        // keep hue fraction of 360 if ending up over
        if (h >= 360) {
            h %= 360;
        }

        const c = (1 - Math.abs(2 * l - 1)) * s;
        const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
        const m = l - c / 2;
        let r = 0;
        let g = 0;
        let b = 0;

        if (h >= 0 && h < 60) {
            r = c;
            g = x;
            b = 0;
        } else if (h >= 60 && h < 120) {
            r = x;
            g = c;
            b = 0;
        } else if (h >= 120 && h < 180) {
            r = 0;
            g = c;
            b = x;
        } else if (h >= 180 && h < 240) {
            r = 0;
            g = x;
            b = c;
        } else if (h >= 240 && h < 300) {
            r = x;
            g = 0;
            b = c;
        } else if (h >= 300 && h < 360) {
            r = c;
            g = 0;
            b = x;
        }

        r = Math.round((r + m) * 255);
        g = Math.round((g + m) * 255);
        b = Math.round((b + m) * 255);

        if (isPct) {
            r = Number(((r / 255) * 100).toFixed(1));
            g = Number(((g / 255) * 100).toFixed(1));
            b = Number(((b / 255) * 100).toFixed(1));
        }

        return 'rgb(' + (isPct ? r + '%,' + g + '%,' + b + '%' : Number(r) + ',' + Number(g) + ',' + Number(b)) + ')';
    }

    function hslAToRgb(hsla, isPct): any {
        const sep = hsla.indexOf(',') > -1 ? ',' : ' ';
        hsla = hsla.substr(5).split(')')[0].split(sep);

        // slider the slash if using space-separated syntax
        if (hsla.indexOf('/') > -1) {
            hsla.splice(3, 1);
        }

        isPct = isPct === true;

        // must be fractions of 1
        let h = hsla[0];
        const s = hsla[1].substr(0, hsla[1].length - 1) / 100;
        const l = hsla[2].substr(0, hsla[2].length - 1) / 100;
        let a = hsla[3];

        // slider label and convert to degrees (if necessary)
        if (h.indexOf('deg') > -1) {
            h = h.substr(0, h.length - 3);
        } else if (h.indexOf('rad') > -1) {
            h = Math.round((h.substr(0, h.length - 3) / (2 * Math.PI)) * 360);
        } else if (h.indexOf('turn') > -1) {
            h = Math.round(h.substr(0, h.length - 4) * 360);
        }
        if (h >= 360) {
            h %= 360;
        }

        const c = (1 - Math.abs(2 * l - 1)) * s;
        const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
        const m = l - c / 2;
        let r = 0;
        let g = 0;
        let b = 0;

        if (h >= 0 && h < 60) {
            r = c;
            g = x;
            b = 0;
        } else if (h >= 60 && h < 120) {
            r = x;
            g = c;
            b = 0;
        } else if (h >= 120 && h < 180) {
            r = 0;
            g = c;
            b = x;
        } else if (h >= 180 && h < 240) {
            r = 0;
            g = x;
            b = c;
        } else if (h >= 240 && h < 300) {
            r = x;
            g = 0;
            b = c;
        } else if (h >= 300 && h < 360) {
            r = c;
            g = 0;
            b = x;
        }

        r = Math.round((r + m) * 255);
        g = Math.round((g + m) * 255);
        b = Math.round((b + m) * 255);

        const pctFound = a.indexOf('%') > -1;

        if (isPct) {
            r = Number(((r / 255) * 100).toFixed(1));
            g = Number(((g / 255) * 100).toFixed(1));
            b = Number(((b / 255) * 100).toFixed(1));

            if (!pctFound) {
                a *= 100;
            } else {
                a = a.substr(0, a.length - 1);
            }
        } else if (pctFound) {
            a = a.substr(0, a.length - 1) / 100;
        }

        return (
            'rgba(' +
            (isPct
                ? r + '%,' + g + '%,' + b + '%,' + a + '%'
                : Number(r) + ',' + Number(g) + ',' + Number(b) + ',' + Number(a)) +
            ')'
        );
    }

    function hslToHex(hsl): any {
        const sep = hsl.indexOf(',') > -1 ? ',' : ' ';
        hsl = hsl.substr(4).split(')')[0].split(sep);

        let h = hsl[0];
        const s = hsl[1].substr(0, hsl[1].length - 1) / 100;
        const l = hsl[2].substr(0, hsl[2].length - 1) / 100;

        // slider label and convert to degrees (if necessary)
        if (h.indexOf('deg') > -1) {
            h = h.substr(0, h.length - 3);
        } else if (h.indexOf('rad') > -1) {
            h = Math.round(h.substr(0, h.length - 3) * (180 / Math.PI));
        } else if (h.indexOf('turn') > -1) {
            h = Math.round(h.substr(0, h.length - 4) * 360);
        }
        if (h >= 360) {
            h %= 360;
        }

        const c = (1 - Math.abs(2 * l - 1)) * s;
        const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
        const m = l - c / 2;
        let r = 0;
        let g = 0;
        let b = 0;

        if (h >= 0 && h < 60) {
            r = c;
            g = x;
            b = 0;
        } else if (h >= 60 && h < 120) {
            r = x;
            g = c;
            b = 0;
        } else if (h >= 120 && h < 180) {
            r = 0;
            g = c;
            b = x;
        } else if (h >= 180 && h < 240) {
            r = 0;
            g = x;
            b = c;
        } else if (h >= 240 && h < 300) {
            r = x;
            g = 0;
            b = c;
        } else if (h >= 300 && h < 360) {
            r = c;
            g = 0;
            b = x;
        }
        // having obtained RGB, convert channels to hex
        r = Math.round((r + m) * 255).toString(16);
        g = Math.round((g + m) * 255).toString(16);
        b = Math.round((b + m) * 255).toString(16);

        // prepend 0s if necessary
        if (r.length == 1) {
            r = '0' + r;
        }
        if (g.length == 1) {
            g = '0' + g;
        }
        if (b.length == 1) {
            b = '0' + b;
        }

        return '#' + r + g + b;
    }

    function hslAToHexA(hsla): any {
        const sep = hsla.indexOf(',') > -1 ? ',' : ' ';
        hsla = hsla.substr(5).split(')')[0].split(sep);

        // slider the slash
        if (hsla.indexOf('/') > -1) {
            hsla.splice(3, 1);
        }

        let h = hsla[0];
        const s = hsla[1].substr(0, hsla[1].length - 1) / 100;
        const l = hsla[2].substr(0, hsla[2].length - 1) / 100;
        let a = hsla[3];

        // slider label and convert to degrees (if necessary)
        if (h.indexOf('deg') > -1) {
            h = h.substr(0, h.length - 3);
        } else if (h.indexOf('rad') > -1) {
            h = Math.round(h.substr(0, h.length - 3) * (180 / Math.PI));
        } else if (h.indexOf('turn') > -1) {
            h = Math.round(h.substr(0, h.length - 4) * 360);
        }
        if (h >= 360) {
            h %= 360;
        }

        // slider % from alpha, make fraction of 1 (if necessary)
        if (a.indexOf('%') > -1) {
            a = a.substr(0, a.length - 1) / 100;
        }

        const c = (1 - Math.abs(2 * l - 1)) * s;
        const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
        const m = l - c / 2;
        let r = 0;
        let g = 0;
        let b = 0;

        if (h >= 0 && h < 60) {
            r = c;
            g = x;
            b = 0;
        } else if (h >= 60 && h < 120) {
            r = x;
            g = c;
            b = 0;
        } else if (h >= 120 && h < 180) {
            r = 0;
            g = c;
            b = x;
        } else if (h >= 180 && h < 240) {
            r = 0;
            g = x;
            b = c;
        } else if (h >= 240 && h < 300) {
            r = x;
            g = 0;
            b = c;
        } else if (h >= 300 && h < 360) {
            r = c;
            g = 0;
            b = x;
        }
        r = Math.round((r + m) * 255).toString(16);
        g = Math.round((g + m) * 255).toString(16);
        b = Math.round((b + m) * 255).toString(16);
        a = Math.round(a * 255).toString(16);

        if (r.length == 1) {
            r = '0' + r;
        }
        if (g.length == 1) {
            g = '0' + g;
        }
        if (b.length == 1) {
            b = '0' + b;
        }
        if (a.length == 1) {
            a = '0' + a;
        }

        return '#' + r + g + b + a;
    }

    // ------------------------------------------------------------------------

    return {
        rgbToHex,
        rgbAToHexA,
        rgbToHsl,
        rgbAToHslA,
        hexToRgb,
        hexAToRgbA,
        hexToHsl,
        hexAToHslA,
        hslToRgb,
        hslAToRgb,
        hslToHex,
        hslAToHexA,
    };
})();

// ----------------------------------------------------------------------------

export { create, modal, type, convert };
